import { Button } from '@components/common/Button';
import { SearchableSelect } from '@components/common/SearchableSelect';

interface DocumentsPagerProps {
  idPrefix?: string;
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
}

const PAGE_SIZE_OPTIONS = [25, 50, 100];
const PAGE_SIZE_SELECT_OPTIONS = PAGE_SIZE_OPTIONS.map((size) => ({
  id: String(size),
  label: String(size),
}));

export const DocumentsPager = ({
  idPrefix = 'documents',
  page,
  pageSize,
  total,
  onPageChange,
  onPageSizeChange,
}: DocumentsPagerProps) => {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const rangeStart = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const rangeEnd = Math.min(page * pageSize, total);

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 px-2 py-3">
      <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
        <label htmlFor={`${idPrefix}-page-size`} className="sr-only">
          Rows per page
        </label>
        <span>Rows per page</span>
        <SearchableSelect
          id={`${idPrefix}-page-size`}
          aria-label="Rows per page"
          options={PAGE_SIZE_SELECT_OPTIONS}
          value={String(pageSize)}
          onChange={(value) => onPageSizeChange(Number(value))}
          placeholder="Rows"
          clearable={false}
          className="w-24"
        />
      </div>

      <div className="text-sm text-gray-600 dark:text-gray-400">
        Showing {rangeStart}-{rangeEnd} of {total}
      </div>

      <div className="flex items-center gap-2">
        <Button
          variant="secondary"
          size="sm"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
        >
          Previous
        </Button>
        <Button
          variant="secondary"
          size="sm"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default DocumentsPager;
